"use client";

import { FC, useRef } from "react";

import { NavFlyoutColumn } from "@types";

import { TranslatedLink } from "components/atoms/TranslatedLink/TranslatedLink";
import { Container } from "components/organisms/Container/Container";

import { StructuredText } from "react-datocms";
import Link from "next/link";
import { CBButton } from "components/InlineBlocks/CBButton";
import { useDropdownLogic } from "./useDropdownLogic";
import s from "./DropdownMenu.module.scss";

interface Props {
  id: string;
  columns: NavFlyoutColumn[];
}

export const DropdownMenu: FC<Props> = ({ id, columns }) => {
  const focusRef = useRef<HTMLUListElement | null>(null);
  const backdropRef = useRef<HTMLDivElement | null>(null);
  useDropdownLogic(focusRef, backdropRef);

  return (
    <div className={s.Wrapper}>
      <div className={s.Backdrop} ref={backdropRef} />
      <div id={id} className={s.Menu}>
        <Container size="l">
          <div className={s.Inner}>
            {columns.map((column, index) => {
              return (
                // eslint-disable-next-line react/no-array-index-key
                <div className={s.Column} key={index}>
                  {column.__typename === "NavFlyoutIntroRecord" && (
                    <>
                      <div className={s.Info}>
                        <h2 className="heading-4">{column.title}</h2>
                        <div className="prose">
                          <StructuredText data={column.text} />
                        </div>
                      </div>
                      {column.cta && <CBButton {...column.cta} />}
                    </>
                  )}
                  {column.__typename === "NavFlyoutLinkListRecord" && (
                    <ul className={s.List} ref={focusRef}>
                      {column.links.map((item) => {
                        if (item.link?.__typename === "ExternalLinkRecord") {
                          return (
                            <li className={s.Item} key={item.id}>
                              <Link href={item.link.url}>
                                <a className={s.Link}>{item.linkText}</a>
                              </Link>
                            </li>
                          );
                        }

                        if (item.link?.__typename === "InternalLinkRecord") {
                          return (
                            <li className={s.Item} key={item.id}>
                              <TranslatedLink record={item.link.link} className={s.Link}>
                                {item.linkText}
                              </TranslatedLink>
                            </li>
                          );
                        }
                        return null;
                      })}
                    </ul>
                  )}
                </div>
              );
            })}
          </div>
        </Container>
      </div>
    </div>
  );
};
